<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-66">
        <edit-profile-form header-color="green"> </edit-profile-form>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-33">
        <user-card button-color="success"> </user-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-66">
        <ExternalLinksForm />
      </div>
    </div>
  </div>
</template>

<script>
import EditProfileForm from '@/views/crm-views/UserProfile/EditProfileForm'
import UserCard from '@/views/crm-views/UserProfile/UserCard'
import ExternalLinksForm from '@/views/crm-views/UserProfile/ExternalLinksForm'
export default {
  components: {
    EditProfileForm,
    UserCard,
    ExternalLinksForm,
  },
}
</script>
<style lang="scss">
.text-right {
  display: flex;
}
</style>
